export const FileAddressGenerator= (defaultResourse: string, fileKey: string) => {
    return `https://${defaultResourse}.mesl.eu/api/v1/Files/${fileKey}/Image.jpg`;
}